/** @format */

import { Box } from '@mui/material';
import DataDetails from './DataDetails/DataDetails';
import { Outlet } from 'react-router-dom';

function Settings() {
  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        height: '100%',
        m: 2,
        display: 'flex',
        justifyContent: 'left',
      }}
    >
      <DataDetails />
    </Box>
  );
}

export default Settings;
